import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { StoreService } from "../../services/store-service";
import styles from "./DescriptionSection.module.css";

const DescriptionSection: React.FC = () => {
  const location = useLocation();
  const selectedServiceId = location.state?.reservation?.categoryId;
  const [description, setDescription] = useState<string | null>(null);

  useEffect(() => {
    const categoriesData = StoreService.GetData("categories");

    if (categoriesData && selectedServiceId) {
      const category = categoriesData.find((cat: any) => cat.id === selectedServiceId);
      if (category?.description) {
        setDescription(category.description);
      }
    }
  }, [selectedServiceId]);

  return (
    <div className={styles.descriptionContainer}>
      {description ? (
        <div
          className={styles.descriptionList}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      ) : (
        <p className={styles.noDescription}>توضیحی برای این سرویس ثبت نشده است   </p>
      )}
    </div>
  );
};

export default DescriptionSection;
